import { TProductVariant } from 'pages/saved-project-configuration/types';
import { formatPrice } from 'common/helpers/format-amount';

export const getVariantText = (variant: TProductVariant): string => {
  const { price, quantity, onePiece } = variant;
  const totalPrice = formatPrice(price * quantity);

  if (onePiece) {
    return `${quantity} шт. x ${onePiece} = ${totalPrice} ₽`;
  }

  return `${quantity} шт. = ${totalPrice} ₽`;
};
